import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectIsAuthenticated } from "../../redux/authentication/selectors";
import { getLocalAccessToken } from "../../utils/helpers";
const PrivateRoute = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const accessToken = getLocalAccessToken();
  const auth = !!(isAuthenticated && accessToken);
  return <>{auth ? children : <Navigate to="/login" />}</>;
};

export default PrivateRoute;
